import React from 'react';
import { motion } from 'framer-motion';
interface ImageGalleryProps {
  images: {
    src: string;
    alt: string;
    caption?: string;
  }[];
  layout?: 'grid' | 'single' | 'masonry';
}
export function ImageGallery({
  images,
  layout = 'single'
}: ImageGalleryProps) {
  if (layout === 'single') {
    return <div className="my-12 w-full overflow-hidden rounded-xl bg-slate-100 shadow-lg" data-id="element-126">
        <img src={images[0].src} alt={images[0].alt} className="w-full h-auto object-cover" data-id="element-127" />
        {images[0].caption && <div className="bg-white p-4 text-sm text-slate-500 border-t border-slate-100 italic" data-id="element-128">
            {images[0].caption}
          </div>}
      </div>;
  }
  return <div className="my-12 grid grid-cols-1 gap-8 md:grid-cols-2" data-id="element-129">
      {images.map((img, index) => <motion.div key={index} initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      delay: index * 0.1
    }} className="overflow-hidden rounded-xl bg-slate-100 shadow-md" data-id="element-130">
          <img src={img.src} alt={img.alt} className="h-64 w-full object-cover md:h-80 lg:h-96 hover:scale-105 transition-transform duration-700 ease-out" data-id="element-131" />
          {img.caption && <div className="bg-white p-4 text-sm text-slate-500 border-t border-slate-100 italic" data-id="element-132">
              {img.caption}
            </div>}
        </motion.div>)}
    </div>;
}